export enum OnboardingLevel {
    NotRegistered,
    VerificationRequired,
    Account,
    BusinessInfo,
    Pricing,
    Invoicing
}